import React, { createContext, useState } from "react";

export const SelectionContext = createContext();

const StoreContext = ({ children }) => {
    const [updateCount, setUpdateCount] = useState({
        all:0,
        mention:0
    });
    const [updateNotification,setUpdateNotification]=useState(false)

    
    return (
        <SelectionContext.Provider value={{ updateCount, setUpdateCount,updateNotification,setUpdateNotification }}>
            {children}
        </SelectionContext.Provider>
    )

}
export default StoreContext